import { date, object, string } from 'yup';

export const GET_ANALYTCS_EVENTS = 'GET_ANALYTCS_EVENTS';

export const OBJECT_ID_REGEX = /^[0-9a-fA-F]{24}$/;

const objectIdValidation = string()
  .optional()
  .test(
    'is-valid-objectid',
    'Id inválido',
    value => !value || OBJECT_ID_REGEX.test(value),
  );

export const EVENTS_FORM_LIST_SCHEMA = object({
  placeId: objectIdValidation,
  deliverymanId: objectIdValidation,
  deliveryId: objectIdValidation,
  startDate: date().optional().nullable(),
  endDate: date().optional().nullable(),
  event: string().optional(),
  cityId: string().optional(),
});
